import PropTypes from 'prop-types';
import { SCROLL_HINT_TEXT } from './scrollZoomHint';

/**
 * TD-2750 — the scroll hint over a canvas (the global .heatmap-scroll-hint), for the hint of
 * useScrollZoomHint. Advisory only: `pointer-events: none` keeps hover and click working through
 * it, and it is hidden from assistive tech because it repeats a mouse/touch affordance rather
 * than carrying content.
 *
 * @param {Object} props
 * @param {'wheel'|'touch'|null} [props.hint] - nothing without one
 * @param {string} [props.className] - more classes for the overlay
 */
const ScrollHintOverlay = ({ hint = null, className = '' }) =>
  hint ? (
    <div className={`heatmap-scroll-hint ${className}`.trim()} aria-hidden="true">
      <span>{SCROLL_HINT_TEXT[hint]}</span>
    </div>
  ) : null;

ScrollHintOverlay.propTypes = {
  hint: PropTypes.oneOf(['wheel', 'touch']),
  className: PropTypes.string
};

export default ScrollHintOverlay;
